import { ChevronRightIcon } from '@heroicons/react/outline';
import { useRouter } from 'next/router';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import { user } from '@/atoms/user';
import { User } from '@/utils/interfaces/User';

interface Props {
  onClose: () => void;
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
}

const PersonalityValue: React.FC<Props> = ({ onClose, setShowDropDown }) => {
  const router = useRouter();

  const userData = useRecoilValue<User | undefined>(user);
  return (
    <ShouldRender
      check={userData?.user_attributes?.find(
        (attr) => attr.attribute_key === 'personality_test',
      )}
    >
      <div
        onClick={() => {
          router.push(
            `/personality_test/${
              userData?.user_attributes?.find(
                (attr) => attr.attribute_key === 'personality_test',
              )?.attribute_value
            }`,
          );
          onClose();
          setShowDropDown(false);
        }}
        className='px-5 w-full flex items-center gap-2 '
      >
        <p className='text-base font-semibold leading-6 tracking-[2.4px] capitalize bg-[linear-gradient(180deg,_#F9742C_0%,_#F20486_100%)] bg-clip-text text-transparent'>
          {
            userData?.user_attributes?.find(
              (attr) => attr.attribute_key === 'personality_test',
            )?.attribute_value
          }
        </p>
        <div className='w-4 h-4 rounded-full bg-[linear-gradient(180deg,_#F9742C_0%,_#F20486_100%)] flex items-center justify-center'>
          <ChevronRightIcon className='w-2.5 h-2.5 stroke-white' />
        </div>
      </div>
    </ShouldRender>
  );
};

export default PersonalityValue;
